import services from "../services";
import * as types from "./mutation-type";

export const ActionGetItemsCart = ({_}, payload) => {
    return new Promise(async(resolve, reject) => {
        const { data } = await services.getItemsCart(payload)
        if(data.error === false) {
            resolve(data)
        }
        reject(data)
    })
}

export const ActionSetItemsCart = ({commit, dispatch}, payload) => {
    commit(types.SET_ITEMS_CART, payload)
    dispatch('ActionSetListCartWithAdditionalProducts', payload);
}

export const ActionSetListCartWithAdditionalProducts = ({commit}, payload) => {
    if(payload.list?.find(el => el.has_childs_additionals == true)) {
        let data = payload.list
        ?.filter(el => {
            el.additional_products = []
            if(el.has_childs_additionals == true) {
                el.additional_products.push(
                    payload.list.filter(p => p.uuid_item_father_cart == el.uuid)
                )
                return el
            }
        })
        return commit(types.SET_LIST_CART_WITH_ADDITIONAL_PRODUCTS, data)
    }
    commit(types.SET_LIST_CART_WITH_ADDITIONAL_PRODUCTS, [])
}

export const setDisabledVariation = ({commit}, payload) => {
    commit(types.SET_DISABLED_VARIATION, payload)
}

export const ActionSetItemCart = ({_}, payload) => {
    return new Promise(async(resolve, reject) => {
        const { data } = await services.seItemCart(payload)
        if(data.error === false) {
            resolve(data)
        }
        reject(data)
    })
}

export const ActionAddItemsCart = ({_}, payload) => {
    return new Promise(async(resolve, reject) => {
        const { data } = await services.addItemsCart(payload)
        if(data.error === false) {
            resolve(data)
        }
        reject(data)
    })
}

export const ActionUpdateItemCart = ({_}, payload) => {
    return new Promise(async(resolve, reject) => {
        const { data } = await services.updateItemCart(payload)
        if(data.error === false) {
            resolve(data)
        }
        reject(data)
    })
}

export const ActionRemoveItemCart = ({_}, payload) => {
    return new Promise(async(resolve, reject) => {
        const { data } = await services.removeItemCart(payload)
        if(data.error === false) {
            resolve(data)
        }
        reject(data)
    })
}

export const ActionDestroyCart = ({_}, payload) => {
    return new Promise(async(resolve, reject) => {
        const { data } = await services.destroyCart(payload)
        if(data.error === false) {
            resolve(data)
        }
        reject(data)
    })
}

export const ActionApplyDiscount = ({_}, payload) => {
    return new Promise(async(resolve, reject) => {
        const { data } = await services.applyDiscount(payload)
        if(data.error === false) {
            resolve(data)
        }
        reject(data)
    })
}

export const ActionApplyDiscountByPayment = ({_}, payload) => {
    return new Promise(async(resolve, reject) => {
        const { data } = await services.applyDiscountByPayment(payload)
        if(data.error === false) {
            resolve(data)
        }
        reject(data)
    })
}

export const ActionApplyIncreaseByPayment = ({_}, payload) => {
    return new Promise(async(resolve, reject) => {
        const { data } = await services.applyIncreaseByPayment(payload)
        if(data.error === false) {
            resolve(data)
        }
        reject(data)
    })
}

export const ActionSendClientOrcamento = ({_}, payload) => {
    return new Promise(async (resolve, reject) => {
        try {
            const { data } = await services.sendClientOrcamento(payload)
            if(data.error === false) {
                resolve(data)
                return
            }
            reject(data)
        } catch (error) {
            reject(error?.response?.data ?? error)
        }
    })
}

export const ActionAddCheckoutKey = ({commit}, payload) => {
  commit(types.SET_CHECKOUT_KEY, payload)
}

export const ActionSetCalledGetItemsCart = ({commit}, payload) => {
    commit(types.SET_CALLED_GET_ITEMS_CART, payload)
}

export const ActionRemoveProductGroup = ({commit}, payload) => {
    return new Promise((resolve, reject) => {
        services.removeProductGroup(payload)
        .then(({data}) => {
            if(data.error === false) {
                return resolve(data)
            }
            reject(data)
        }).catch((err) => {
            reject(err)
        });
    })
}

export const ActionValidateSupplier = ({_}, payload) => {
    return new Promise(async(resolve, reject) => {
        const { data } = await services.getValidateSupplier(payload)
        if(data.error === false) {
            resolve(data)
        }
        reject(data)
    })
}
